import React, { Component } from "react";
import "./index.less"

class CuttingLine extends Component {

    render() {
        return <ul className="cutting-line" style={this.props.style || {}}>
            <li className="tilte">{this.props.children}</li>
        </ul>
    }
}

export default CuttingLine


// WEBPACK FOOTER //
// ./src/components/CuttingLine/index.js